define('app/directives/column_picker',['angular', 'app/services/shared'], function (angular) {
  var module = angular.module('app.columnpicker', ['app.shared'])

  module.controller('columnPickerController', ['$scope', '$timeout', '$mdDialog', 'grid', 'columns', function (scope, $timeout, $mdDialog, grid, columns) {
      var pickerVm = this;
      pickerVm.columns = columns;
      pickerVm.ok = function () {
		  $mdDialog.hide()
      };

      pickerVm.cancel = function () {
		  $mdDialog.hide()
      };

      pickerVm.setVisibility = function (index, visible) {
		  pickerVm.columns[index].active = !pickerVm.columns[index].active;
          //grid.$gridScope.columns[index].toggleVisible();
      };
  }]);

    module.directive('bitarrayAsTimerange', ['$parse', function ($parse) {
        var directive = {
            restrict: 'A',
            require: ['ngModel'],
            link: link
        };
        return directive;

        function toHHMM(min) {
            var prefix = '';

            if(min < 1440) {
                prefix = '-';
            } else if(min <= 2880) {
                min -= 1440;
            } else {
                min -= 2880;
                prefix = '+';
            }
            var minStr = ("0" + (min % 60)).slice(-2);
            var hourStr = ("0" + (Math.floor(min/60))).slice(-2);

            return prefix + hourStr + ':' + minStr;
        }

        function tryAndget(element)
        {
            var regHexHHMM = /^([\+-]?)([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
            var match = element.match(regHexHHMM);
            if (match == null)
                return null;

            var initVal = 1440;
            if (match[1] === '+')
                initVal = 2880;
            else if(match[1] === '-')
                initVal = 0;

            var hour = parseInt(match[2]) * 60;
            var mins = parseInt(match[3]);
            return initVal + mins + hour;
        }

        function timeRangesToBitArray(input)
        {
            var ba = new BitArray(1440*3, false, false);
            var words = input.split(/,/);
            for (var index = 0; index < words.length; index++) {
                var element = words[index].trim();
                var to = 0;

                var from = tryAndget(element);
                if (from != null) {
                    ba.setUnos(from, from + 1);
                }
                else {
                    var splitOn = element.indexOf("-", 1);
                    if (splitOn != -1) {
                        var l = element.substring(0, splitOn).trim();
                        from = tryAndget(l);
                        if (from != null) {
                            var r = element.substring(splitOn+1).trim();
                            to = tryAndget(r);
                            if (to != null) {
                                ba.setUnos(from, to);
                            }
                        }
                    }
                }
            }
            return ba;
        }

        function bitarrayToTimeRanges(ba)
        {
            var minutes = ba.getNumberOfUnos();
            if (minutes == 0) return null;

            var ss = '';
            var nb = ba.getNumberOfBloques();
            for(var i=0; i<nb; i++){
                var iniFin = ba.getBloque(i);
                if (i !== 0)
                    ss += ', ';
                ss += toHHMM(iniFin[0]);

                if (iniFin[1] == iniFin[0] + 2) {
                    ss += ', ' + toHHMM(iniFin[1]);
                }
                else if (iniFin[1] > iniFin[0] + 2) {
                    ss += '-' + toHHMM(iniFin[1]);
                }
            }
            return ss;
        }

        function link(scope, element, attr, ctrls) {
            var ngModelController = ctrls[0];

            // from editbox to model
            ngModelController.$parsers.push(function (viewValue) {
                if (!viewValue) {
                    return null;
                }

                var ba = timeRangesToBitArray(viewValue);
                return ba.Encode64(ba);
            });

            // from model to editbox
            ngModelController.$formatters.push(function (modelValue) {
                if (!modelValue) {
                    return null;
                }
                
                var ba = BitArray.Parse64(modelValue);
                return bitarrayToTimeRanges(ba);
            });
        }
    }]);

  module.directive('numberAsHoraMinuto', ['$parse', function ($parse) {
    var directive = {
      restrict: 'A',
      require: ['ngModel'],
      link: link
    };
    return directive;

    function toHHMM(min) {
      var prefix = '';

      if(min < 0) {
		min = min * -1;
        prefix = '-';
      }

      var minStr = ("0" + (min % 60)).slice(-2);
      var hourStr = ("0" + (Math.floor(min/60)))/*.slice(-2)*/;

      return prefix + hourStr + ':' + minStr;
    }

    function link(scope, element, attr, ctrls) {
      var ngModelController = ctrls[0];

      // called with a JavaScript Date object when picked from the datepicker
      ngModelController.$parsers.push(function (viewValue) {
        if (typeof  viewValue === "number")
          return viewValue;

        var regHexHHMM = /^([\-]?)([0-9]*):([0-5][0-9])$/;

        var match = viewValue.match(regHexHHMM);
        if (match == undefined || match == null)
          return undefined;

        var multi = 1;
        if (match[1] === '-')
          multi = -1;

        var hour = parseInt(match[2]) * 60;
        var mins = parseInt(match[3]);
        return multi * (mins + hour);
      });

      // called with a 'yyyy-mm-dd' string to format
      ngModelController.$formatters.push(function (modelValue) {

        if (!modelValue) {
          return undefined;
        }
        return toHHMM(modelValue);
      });
    }
  }]);
	  
  module.directive('numberAsHoraMinutoPlus', ['$parse', function ($parse) {
    var directive = {
      restrict: 'A',
      require: ['ngModel'],
      link: link
    };
    return directive;

    function toHHMM(min) {
      var prefix = '';

      if(min < 1440) {
        prefix = '-';
      }
	  else if(min < 2880) {
        min -= 1440;
      }
      else {
        min -= 2880;
        prefix = '+';
      }

      var minStr = ("0" + (min % 60)).slice(-2);
      var hourStr = ("0" + (Math.floor(min/60))).slice(-2);

      return prefix + hourStr + ':' + minStr;
    }

    function link(scope, element, attr, ctrls) {
      var ngModelController = ctrls[0];

      // called with a JavaScript Date object when picked from the datepicker
      ngModelController.$parsers.push(function (viewValue) {
        if (typeof  viewValue === "number")
          return viewValue;

        var regHexHHMM = /^([\+-]?)([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;

        var match = viewValue.match(regHexHHMM);
        if (match == undefined || match == null)
          return undefined;

        var initVal = 1440;
        if (match[1] === '+')
          initVal = 2880;
        else if(match[1] === '-')
          initVal = 0;

        var hour = parseInt(match[2]) * 60;
        var mins = parseInt(match[3]);
        return initVal + mins + hour;
      });
        
      // called with a 'yyyy-mm-dd' string to format
      ngModelController.$formatters.push(function (modelValue) {

        if (!modelValue) {
          return undefined;
        }
        return toHHMM(modelValue);
      });
    }
  }]);
  
    module.directive('numberAsDate', ['$parse', function ($parse) {
    var directive = {
      restrict: 'A',
      require: ['ngModel'],
      link: link
    };
    return directive;
/*
    function toDate(dayId) {
	  var dt = new Date(1970,0,1);
	  var newdate = new Date(dt);
	  newdate.setDate(newdate.getDate() + dayId);
	  return newdate;
    }
*/
    function link(scope, element, attr, ctrls) {
      var ngModelController = ctrls[0];

      // called with a JavaScript Date object when picked from the datepicker
      ngModelController.$parsers.push(function (viewValue) {
        if (typeof  viewValue === "number")
          return viewValue;

		var numDays = Math.round(Math.abs((viewValue - new Date(1970,0,1))/86400000));
		//console.log(numDays);

        return numDays;
      });

      ngModelController.$formatters.push(function (modelValue) {
        if (!modelValue) {
          return undefined;
        }
		return new Date(1970,0,modelValue+1);
        //return toDate(modelValue);
      });
    }
  }]);


  module.directive('columnPicker', ['$mdDialog', function ($mdDialog) {
        return {
            restrict: 'A',
            scope: {
                'columnPicker': '='
            },
            link: function ($scope, $element, $attrs) {
                $scope.grid = $scope.columnPicker;
                $scope.columns = $scope.columnPicker.columns;

                function open() {
                    var modalInstance = $mdDialog.show({
                        controller: 'columnPickerController',
                        controllerAs: 'pickerVm',
                        resolve: { columns: function () { return $scope.columns; }, grid: function () { return $scope.grid; } },
                        template: '<md-dialog ng-cloak> <form> \
                                   <md-toolbar> \
                                     <div class="md-toolbar-tools"> \
                                       <h2>Selecciona columnes</h2> \
                                       <span flex></span> \
                                       <md-button class="md-icon-button" ng-click="pickerVm.cancel()"> \
                                         <md-icon md-svg-icon="navigation:ic_close_24px" aria-label="Close dialog"></md-icon> \
                                       </md-button> \
                                     </div> \
                                   </md-toolbar> \
                                   <md-dialog-content flex layout-padding> \
                                        <div class="row"> \
                                            <div class="col-xs-12"> \
                                                <table class="table table-striped table-bordered"> \
                                                    <tr ng-repeat="c in pickerVm.columns"> \
                                                        <td width="75%"> \
                                                            {{c.title}} \
                                                        </td> \
                                                        <td> \
														  <md-switch ng-model="c.active" aria-label="{{c.name}}"> \
															  {{c.name}}\
														  </md-switch> \
                                                        </td> \
                                                    </tr> \
                                                </table> \
                                            </div> \
                                        </div> \
                                   </md-dialog-content> \
                                   <md-dialog-actions layout="row"> \
                                   <span flex></span> \
                                   <md-button ng-click="pickerVm.ok()" md-autofocus>Tancar</md-button> \
                                   </md-dialog-actions></form> \
								   </md-dialog>',
                        size: 'md'
                    });
                }

                $element.bind('click', function (event) {
                    open();
                });
            }
        };
    }
  ]);
  return module
})
;
